import React from "react";
import { BrowserRouter as Router, Link, Route } from "react-router-dom";
import "./App.css";
import bgBanner from "./logo.png";
import { About } from "./pages/About";
import { Archive } from "./pages/Archive";
import { Index } from "./pages/Index";

const App: React.FC = () => {
  return (
    <Router>
      <div className="pane">
        <div className="header">
          <Link to="/">
            <img height="65px" src={bgBanner} alt="Peep" />
          </Link>
        </div>

        <div className="topbanner">
          <Link to="/">Today's Strip</Link>
          <Link to="/archive">Archive</Link>
          <Link to="/about">About</Link>
        </div>

        <div className="main">
          <Route exact path="/" component={Index} />
          <Route exact path="/archive" component={Archive} />
          <Route exact path="/comic/:posted" component={Index} />
          <Route exact path="/about" component={About} />
        </div>
      </div>

      <p className="footer">
        Peep © 2016-{new Date().getFullYear()} <Link to="/about">Contact</Link>
      </p>
    </Router>
  );
};

export default App;
